module.exports = __webpack_public_path__ + "img/portada-1.a91790f8.png";